import StorageHelper from "../helpers/StorageHelper";
const storageHelper = new StorageHelper();

export class SiafLiteApiStream {
  constructor(url) {
    this.url = url;
    const localStorageToken = storageHelper.getLocal("token");
    this.authorization = `Bearer ${localStorageToken}`;
  }

  async get(filter) {
    let urlGet = this.url;
    if (filter) {
      urlGet = gerarUrlComFiltro(this.url, filter);
    }
    return fetch(urlGet, {
      method: "GET",
      headers: {
        Authorization: this.authorization,
      },
    });
  }

  async post(body) {
    return fetch(this.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
      },
      body: JSON.stringify(body),
    });
  }

  async put(id, body) {
    let urlPut = `${this.url}/${id}`;
    return fetch(urlPut, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
      },
      body: JSON.stringify(body),
    });
  }

  async path(body) {
    return fetch(this.url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
      },
      body: JSON.stringify(body),
    });
  }
}

function gerarUrlComFiltro(url, filter) {
  let filtroString = "";
  for (const key in filter) {
    if (filter[key]) {
      const parametroFilro = filter[key]?.toString().replaceAll(/\s/g, "+");
      if (filtroString) {
        filtroString += `&${key}=${parametroFilro}`;
      } else {
        filtroString += `${key}=${parametroFilro}`;
      }
    }
  }
  return `${url}?${filtroString}`;
}
